module.exports = __webpack_public_path__ + "img/mem_coupon_font3_m.c42add5e.jpg";